export default __webpack_public_path__ + "static/media/flex.2961f919.svg";